module.exports = __webpack_public_path__ + "fonts/Barlow-Thin.c9f1e473.ttf";